export const numberFormat = (
  value: number,
  style: 'decimal' | 'currency' | 'percent',
  display: 'short' | 'long',
  floatNumber = 0,
  notation: 'compact' | 'standard' = 'compact'
): string => {
  const formattedValue = new Intl.NumberFormat(
    'en-US',
    {
      style,
      currency: 'USD',
      notation,
      compactDisplay: display,
      minimumFractionDigits: floatNumber
    }).format(value);
  return formattedValue;
};

//To find the minimum value in an array of objects based on a key params
export const findMinValue = <T>(data: T[], ...keys: (keyof T)[]): number => {
  if (data.length === 0 || keys.length === 0) {
    return 0;
  }

  let minValue = 0;

  data.forEach((item) => {
    keys.forEach((key) => {
      const value = item[key];

      if (typeof value === 'number') {
        minValue = minValue === undefined ? value : Math.min(minValue, value);
      }
    });
  });

  return minValue;
};

export const recursiveGroupData = (data, types, currentLevel = 0) => {
  if (currentLevel >= types.length || data.length === 0) {
    return data;
  }

  const result = {};
  data.forEach((item) => {
    let key;

    switch (types[currentLevel]) {
      case 'year':
        key = item.year;
        break;
      case 'quarter':
        key = item.quarter;
        break;
      case 'month':
        key = item.month;
        break;
      case 'week':
        key = item.week;
        break;
    }

    if (!result[key]) {
      result[key] = [];
    }

    result[key].push(item);
  });

  for (const key in result) {
    result[key] = recursiveGroupData(result[key], types, currentLevel + 1);
  }

  return result;
};

export const sumRecursive = (currentData, totals) => {
  if (Array.isArray(currentData)) {
    currentData.forEach((item) => {
      totals.current_year_week_revenue += item.current_year_week_revenue;
      totals.last_year_week_revenue += item.last_year_week_revenue;
      totals.previous_week_revenue += item.previous_week_revenue;
    });
  } else if (typeof currentData === 'object') {
    Object.values(currentData).forEach((value) => sumRecursive(value, totals));
  }
};

export const calculateSums = (data) => {
  const totals = {
    current_year_week_revenue: 0,
    last_year_week_revenue: 0,
    previous_week_revenue: 0,
  };

  sumRecursive(data, totals);

  const year_over_year_change = (totals.current_year_week_revenue - totals.last_year_week_revenue) / (totals.last_year_week_revenue || 1) * 100;
  const week_over_week_change = (totals.current_year_week_revenue - totals.previous_week_revenue) / (totals.previous_week_revenue || 1) * 100;

  return {
    ...totals,
    year_over_year_change,
    week_over_week_change
  };
};

// Custom sort function for months names
export const sortMonths = (a, b) => {
  const months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
  return months.indexOf(a) - months.indexOf(b);
};
